<template>
    <iframe
        v-bind:width="width"
        v-bind:height="height"
        v-bind:src="source"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
    ></iframe>
</template>

<script>
    export default {
        /**
         * Define the properties passed into the component from the parent.
         *
         * @link https://vuejs.org/v2/guide/components.html#Props
         */
        props: {
            width: {
                type: [
                    String,
                    Number,
                ],
                default: '640',
            },
            height: {
                type: [
                    String,
                    Number,
                ],
                default: '360',
            },
            source: {
                type: String,
                required: true,
            },
        },
    };
</script>
